export default {
    post: function (url, data) {
        return new Promise(function (resolve, reject) {
            const errors = [];
            //Email is required
            if (data.email == null || data.email === '') {
                errors.push(
                    {
                        property: 'Email',
                        message: 'MESSAGE__ACCOUNT__EMAIL_REQUIRED'
                    }
                );
            } else {
                //Email is not valid
                const re = /\S+@\S+\.\S+/;
                if (!re.test(data.email)) {
                    errors.push(
                        {
                            property: 'Email',
                            message: 'MESSAGE__ACCOUNT__EMAIL_NOT_VALID'
                        }
                    );
                }
            }

            //Password is required
            if (data.password == null || data.password === '') {
                errors.push(
                    {
                        property: 'Password',
                        message: 'MESSAGE__ACCOUNT__PASSWORD_REQUIRED'
                    }
                );
            }

            //Password confirmation is required
            if (data.confirmPassword == null || data.confirmPassword === '') {
                errors.push(
                    {
                        property: 'ConfirmPassword',
                        message: 'MESSAGE__ACCOUNT__CONFIRM_PASSWORD_REQUIRED'
                    }
                );
            }

            //Password confirmation is invalid
            if (data.confirmPassword !== data.password) {
                errors.push(
                    {
                        property: 'ConfirmPassword',
                        message: 'MESSAGE__ACCOUNT__PASSWORD_CONFIRMATION_NOT_VALID'
                    }
                );
            }

            //Terms are not accepted
            if (data.termsAccepted == null || data.termsAccepted === false) {
                errors.push(
                    {
                        property: 'TermsAccepted',
                        message: 'MESSAGE__ACCOUNT__TERMS_NOT_ACCEPTED'
                    }
                );
            }

            //Name is required
            if (data.name == null || data.name === '') {
                errors.push(
                    {
                        property: 'Name',
                        message: 'MESSAGE__ACCOUNT__NAME_REQUIRED'
                    }
                );
            }

            //Company is required
            if (data.company == null || data.company === '') {
                errors.push(
                    {
                        property: 'Company',
                        message: 'MESSAGE__ACCOUNT__COMPANY_NAME_REQUIRED'
                    }
                );
            }

            //Timezone is required
            if (data.timezone == null || data.timezone === '') {
                errors.push(
                    {
                        property: 'Timezone',
                        message: 'MESSAGE__ACCOUNT__TIMEZONE_REQUIRED'
                    }
                );
            }

            //Invalid credentials
            if (errors.length>0) {
                reject({
                    status: 400,
                    body: errors
                });
                return;
            }

            //Ok
            resolve({
                body: {
                    email: 'john@test.com',
                    token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c'
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./test/data/account/signup.js